import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const chargeIntervalsAdapter = getAdapter({ idFieldName: 'value' });

const chargeIntervalsSlice = createSlice({
    name: 'chargeIntervals',
    initialState: chargeIntervalsAdapter.getInitialState(),
    reducers: {
        setChargeIntervals: (state, { payload: { chargeIntervals } }) => {
            chargeIntervalsAdapter.setAll(state, chargeIntervals);
        },
    },
});

const selectors = chargeIntervalsAdapter.getSelectors(({ chargeIntervals }) => chargeIntervals);

export const getChargeIntervals = (state) => selectors.selectAll(state);

export const {
    setChargeIntervals,
} = chargeIntervalsSlice.actions;

export default chargeIntervalsSlice.reducer;
